import { motion } from "framer-motion";

export const Rich = ({ html, className = "", testid }) => (
  <div className={`rich ${className}`} data-testid={testid} dangerouslySetInnerHTML={{ __html: html || "" }} />
);

export const Reveal = ({ children, delay = 0, className = "", style }) => (
  <motion.div
    className={className}
    style={style}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-block h-[2px] w-12 bg-brass ${className}`} aria-hidden>
    {children}
  </span>
);
